import { z, ZodType } from 'zod';

export type Settings = {
	maxBet: number;
	minBet: number;
	maxWin: number;
	multipliers: {
		[key: string]: number[];
	};
	currency: string;
	language: string;
	username: string;
	returnUrl: string;
	fastBets: number[];
};

export const settingsSchema: ZodType<Settings> = z.object({
	maxBet: z.number(),
	minBet: z.number(),
	maxWin: z.number(),
	multipliers: z.record(z.string(), z.number().array()),
	currency: z.string(),
	language: z.string(),
	username: z.string(),
	returnUrl: z.string(),
	fastBets: z.number().array(),
});
